import * as Yup from 'yup';

export default Yup.object().shape({
  distributor: Yup.object().required('SCHEMA_ERRORS.DISTRIBUTOR_REQUIRED'),
});
